import type { ActionFunction } from '@remix-run/node';
import { json } from '@remix-run/node';
import invariant from 'tiny-invariant';
import type {
    MigrateInspirationMutation,
    MigrateInspirationMutationVariables,
} from 'generated/graphql';
import { MigrateInspirationDocument } from 'generated/graphql';

export const MIGRATE_BUILD_HUB_INSPIRATION_API_ROUTE =
    '/remix-api/app/build-hub-inspiration-migrate';

const DEFAULT_FAILED_MESSAGE =
    'Failed to migrate design board as BuildHub inspiration.';

/**
 * Action to migrate a new design board and its contents as inspiration on a BuildHub.
 */
export const action: ActionFunction = async ({ request, context }) => {
    const data = await request.formData();

    invariant(data.get('id'), 'No BuildHub ID submitted for migrate.');
    invariant(
        data.get('designBoardId'),
        'No design board ID submitted for migrate.'
    );

    const variables: MigrateInspirationMutationVariables = {
        BuildHubID: data.get('id') as string,
        IdeaBookID: data.get('designBoardId') as string,
    };

    const parentId = data.get('parentId');
    if (parentId) {
        variables.ParentID = Number(parentId);
    }

    try {
        const { data: result } = await context.client.mutate<
            MigrateInspirationMutation,
            MigrateInspirationMutationVariables
        >({
            mutation: MigrateInspirationDocument,
            variables,
        });

        const validResult = result?.projectInspirationIdeaBookMigrate;
        if (!validResult) {
            return json({
                buildHubUpsert: {
                    __typename: 'ServerError',
                    Message: DEFAULT_FAILED_MESSAGE,
                },
            });
        }

        return json(result);
    } catch (error) {
        return json({
            buildHubUpsert: {
                __typename: 'ServerError',
                Message:
                    error instanceof Error
                        ? error.message
                        : DEFAULT_FAILED_MESSAGE,
            },
        });
    }
};
